export default __webpack_public_path__ + "static/media/card_brand.214405d4.jpg";